define(function(require) {
  	const builder = require('civicsUtils/buildUrlParameters');
	  const IpsModel = require('civicsBase/ipsModel');
	  const JSV = require('civicsUtils/JSV');
    const Logger = require('civicsUtils/application/logger');
    const cache_utility = require('civicsUtils/cache_utility');
    return Backbone.Collection.extend({
			model:IpsModel,
    // Add a model, or list of models to the set.
    add: function(models, options) {
      var res = Backbone.Collection.prototype.add.apply(this, arguments);
      return res;
    },
    resetKeyValues:function(binds){
      var self = this;
      if ( _.isArray(binds) && binds.length > 0 ){
        _.forEach(binds, b=>{
          self.resetKeyValue(b);
        });
      }
    },
    resetKeyValue:function(bind){
      var self = this;
      if ( bind && bind.trim().length > 0){
        _.forEach(this.models, m=>{
          m.resetKeyValue(bind);
        });
      }
    },
    toJSON: function(options) {
      var primAttrs = [];
      for (var model in this.models) {
          primAttrs.push( this.models[model].toJSON() );
        }
      return _.clone(primAttrs);
    },
    fetch : function(options) {
      var self = this;
      var urlText = _.isFunction(this.url)? this.url(): this.url;
      let localCacheEnabled = options && options.localCacheEnabled;
      if ( urlText && options && options.isSensitive ) urlText=urlText.split("?")[0];
      var start = new Date();

      var promise;

      if (urlText && ((window.origin.length + urlText.length) > 2048 ) ){
        console.log("URL is too long and throwing an error");
        promise = $.Deferred();
        
        promise.reject( {responseJSON: {responseStatus: {message : i18n.t('CIVICS.COMMON.URL_LONG') } } } );
			} else {
        if(localCacheEnabled){
          promise = self.checkLocalCacheData(urlText,options);
        }
        if(!promise){
          promise = Backbone.Collection.prototype.fetch.apply(this, arguments)
          .done(function(result){
            if(localCacheEnabled){
              // note to dev: on parsing of the model, we need the structuredClone() to clone the response data of the fetch before modifying it on the parse so that the result will still return the original value from server
              // we need to save the result that is not yet modify by parse so that when we get it from cache and execute the parse, the result of parsing will still be the same.
             cache_utility.saveModelCacheData(urlText,options.localCacheGroupName,result);
            }
            self.setClean();
            var diff =  Math.abs(new Date() - start );
            Logger.logInfo('ipsModelCollection:FetchSuccess'+diff+'ms:'+urlText);
          })
          .fail(function(jqXHR,textStatus,errorThrown){
            var code = jqXHR.status;
            var text = textStatus;
            var error = errorThrown?errorThrown:'';
            var diff =  Math.abs(new Date() - start );
            Logger.logError('ipsModelCollection:FetchFailed:'+
              diff+'ms:' +
              urlText +
              '[status:' +
              code + ', text:' +
              text + ', thrown: ' +
              error + ']');
          })
          .then();
        }
      }
      return promise;
    },
    // use to check the cache if we have the data base on the url request
    // return it as the response of fetch and execute the option.success if we have it
    checkLocalCacheData: function(key,options){
      // always remove the expired data on cache before checking it
      cache_utility.clearInvalidCacheData();
      
      let requestCacheData = cache_utility.getModelCacheData(key);
      if(requestCacheData && requestCacheData.length > 0){
        retVal = requestCacheData[0].values;
        var def = $.Deferred();
        // if we found the data on cache, we need to execute the this.parse() to execute the model parse and set the result on current model
        let parseDataResult = this.parse(requestCacheData[0].values); 
        this.set(parseDataResult)
        if (options && options.success){
          // we need to execute the success from option because this will not be executed on resolve
          options.success(this,parseDataResult);
        }

        return def.resolve(retVal,'Success');
      }
      return;
    },
    setClean: function(){
      for (var model in this.models) {
        if ( _.isObject(model) && val.setClean ){
          model.setClean();
        }
      }
    },
    hasChanged: function(){
      var isChanged = false
      for (var model in this.models) {
        if ( _.isObject(model) && val.hasChanged ){
          isChanged = isChanged || val.hasChanged();
        }
      }
      return isChanged;
    },
    formatUrlRoot: function(){
      this.urlRoot = this.urlRoot.format.apply(this.urlRoot,arguments);
    },
		// calling sort on the ips won't bother changing the
		// instance's comprator. it build one on the fly every time
		// this method is called based on the passed in attributename and direction
		sort: function(attributeName,direction,options) {
			// if the first params is passed in as an object,
			// let base sort handle this
			if ( _.isObject(attributeName)){
				return Backbone.Collection.prototype.sort.apply(this, arguments)
			}

      options || (options = {});
			var comparator = function(a, b){
				var aVal = '';
				var bVal = '';

				if (a.has(attributeName) && typeof a.get(attributeName) != 'undefined' ){
					aVal = a.get(attributeName);
				}
				if (b.has(attributeName) && typeof b.get(attributeName) != 'undefined' ){
					bVal = b.get(attributeName);
				}

				var res = 1;
				if(typeof aVal == 'number' && typeof bVal == 'number'){
					if (aVal < bVal)
						res = -1;
					else if (aVal == bVal)
						res = 0;
					else
						res = 1;
				} else {
					if (aVal.toString().toLowerCase() < bVal.toString().toLowerCase())
						res = -1;
					else if (aVal.toString().toLowerCase() == bVal.toString().toLowerCase())
						res = 0;
					else
						res = 1;
				}

			 if ( direction && direction.toUpperCase() == 'DESC'){
	 					res = res * -1;
 				}
				return res;

			};
			_.bind(comparator, this);
      this.models.sort(comparator);
      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },
    url: function() {
			// generate url
			var url = this.urlRoot;
			if (this.urlParameters) {
				url += builder.buildUrlParameters(this.urlParameters)
			}
			return url;
		},
    parse:function(r){
      //if (__DEV__)console.log('collection response', r);
      this.responseStatus = r.responseStatus;
      return r.data;
  },
  //ecode the url component
  encodeComponent: function (val) {
	  //return val;
	  val = JSV.escapeString(val);
	  return encodeURIComponent(val);

  }
  });
});
